// @flow
import type { LayoutReminderMailDataAction } from '../types/layout_reminder_mail';

export const changeLayoutReminderMailAction = (payload: object): LayoutReminderMailDataAction => {
    return {
        type: 'CHANGE_LAYOUT_REMINDER_MAIL',
        payload,
    };
};
